import Vue from "vue";

// app
import App from "./App.vue";

// router
import router from "./routers/router.js";

import 'fullpage.js/vendors/scrolloverflow.js'
// import 'vue-fullpage.js/node_modules/fullpage.js'
import VueFullPage from 'vue-fullpage.js'
import './utils/fullpages.mini.css'

Vue.use(VueFullPage)

// bootstrap-vue
import BootstrapVue from "bootstrap-vue";
// import Scrollspy from 'vue2-scrollspy';

Vue.use(BootstrapVue);
// Vue.use(Scrollspy);
// or custom options
// Vue.use(Scrollspy, options);
import VueScrollTo from 'vue-scrollto';
let scrollOptions = {
  container: "body", //滚动的容器
  duration: 500, //滚动时间
  easing: "ease", //缓动类型
  offset: -50, // 滚动时应应用的偏移量。此选项接受回调函数
  force: true, // 是否应执行滚动
  cancelable: true, // 用户是否可以取消滚动
  onStart: false, // 滚动开始时的钩子函数
  onDone: false, // 滚动结束时候的钩子函数
  onCancel: false, // 用户取消滚动的钩子函数
  x: false, // 是否要在x轴上也滚动
  y: true    // 是否要在y轴上滚动
};
Vue.use(VueScrollTo, scrollOptions);
// import 'vue2-animate/dist/vue2-animate.min.css'
// bootstrap-vue css


/* 引入swiper及其相关组件 */
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueAwesomeSwiper)
/* 引入swiper及其相关组件 */

// 使用animate.css
import animated from 'animate.css'
import "swiper/dist/css/swiper.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(animated)
// 滚动动画 wow.js
import { WOW } from 'wowjs'
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // default
  animateClass: 'animated', // default
  offset: 150, // default
  mobile: true, // default
  live: false,

  // live为true时，控制台会提示：MutationObserver is not supported by your browser. & WOW.js cannot detect dom mutations, please call .sync() after loading new content.

  callback: function (box) {
    console.log("WOW: animating <" + box.tagName.toLowerCase() + ">")
  }
});
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

// vue config
Vue.config.productionTip = false; // 设置为 false 以阻止 vue 在启动时生成生产提示。(默认值：true)
// Vue.config.devtools = false; // 配置是否允许 vue-devtools 检查代码。(默认值：true)
// Vue.config.silent = true;// 取消 Vue 所有的日志与警告。(默认值：false)

// render
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
